import {
  ActivityFilterKey
} from '@gripp/shared-logic';
import {
  ActivityFilterScreen,
  ActivityFilterScreenHandle,
  ActivityList,
  SlideAction,
  SlideLayout,
  useSlideLayout,
  ViewMode
} from '@gripp/shared-ui';
import { useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ActivityFilters } from '../../activity/components/activityFilters';
import { HeaderResetButton } from '../../shared/components/headerResetButton';

export const AssetDetailFilter = () => {
  const { assetId } = useParams();
  const filterRef = useRef<ActivityFilterScreenHandle>(null);

  if (!assetId) {
    return null;
  }

  const leftColumn = {
    title: 'activity.header.title',
    mainComponent: <LeftColumn assetId={assetId} />,
    headerComponent: (
      <ActivityFilters
        assetId={assetId}
        showAddButton={false}
        showFilterButton={false}
      />
    ),
    showBackButton: true,
    disableScroll: true,
    backButtonTransition: SlideAction.PREV
  };
  
  const rightColumn = {
    title: 'assets.menu.title',
    mainComponent: (
      <ActivityFilterScreen
        ref={filterRef}
        mode="page"
        isVisible={true}
        filterKey={ActivityFilterKey.AssetActivity}
        assetId={assetId}
        bottomBar={() => <></>}
      />
    ),
    headerComponent: (
      <HeaderResetButton
        onReset={() => filterRef.current?.onReset()}
      />
    ),
    showBackButton: true,
    disableScroll: true,
  }; 

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const LeftColumn = ({ assetId }: { assetId: string }) => {
  const { onSlideChange } = useSlideLayout();
  const navigate = useNavigate();
  
  const onIssueSelected = async (issueId: string) => {
    await onSlideChange(SlideAction.NEXT);

    navigate(`/assets/${assetId}/activity/${issueId}`);
  };

  return (
    <ActivityList
      filterKey={ActivityFilterKey.AssetActivity}
      onIssueSelected={onIssueSelected}
      assetId={assetId}
      showAssetName={false}
      showImage={false}
      pageSize={50}
      showTopBar={false}
    />
  );
};